define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 地理围栏编辑模式。
     *
     * @exports EnumGeoFenceEditMode
     * 
     * @see GeoFence#editMode
     */
    var EnumGeoFenceEditMode = {
        /**
         * 展示模式。
         * @type {String}
         * @constant
         */
        SHOW: "SHOW",
        /**
         * 创建模式。
         * @type {String}
         * @constant
         */
        CREATE: "CREATE"
    }
    freezeObject(EnumGeoFenceEditMode)
    /**
     * 反向查找对齐方式的名称。
     * 
     * @param {String} value 对齐方式的数值。
     * @returns {String} 对齐方式的名称。
     */
    function getName(value) {
        for (var key in EnumGeoFenceEditMode) {
            if (EnumGeoFenceEditMode.hasOwnProperty(key) && EnumGeoFenceEditMode[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        SHOW: "SHOW",
        CREATE: "CREATE",
        getName: getName
    }
})